module.exports = __webpack_public_path__ + "img/e&o_insurance_required.61d64856.svg";